<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex flex-row text-primary pl-2 pr-2 pb-4 ">
        <i class="fas fa-quote-left pr-2"></i>
        <label class="m-0">{{ text }}</label>
        <i class="fas fa-quote-right pl-2 align-self-end"></i>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
export default {
    data () {
        return { };
    },
    props: {
         text: {
            required: true,
            type: String,
        },
    }
};
</script>
